module.exports = __webpack_public_path__ + "img/featured.64abcfb1.jpg";